const MidAnchorSection = () => {
  const chips = ["Rétegezett design", "Kártyás felépítés", "Konverzió fókusz", "Mobil sticky CTA"];

  return (
    <section data-testid="mid-anchor-section" className="dark-section py-24 md:py-32 relative overflow-hidden">
      <div className="blur-blob blur-blob-3" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-on-dark leading-tight">
          Ügynökségi szintű megjelenés —{" "}
          <span className="text-gradient">egyszerű, kontrollált folyamattal</span>
        </h2>

        <p className="scroll-animate mt-6 text-on-dark/70 text-base sm:text-lg">
          Nem "olcsó honlap". Célzott landing, ami tisztán kommunikál és döntésre segít.
          <br />
          A végeredmény prémium érzetű, mégis gyorsan elkészül, mert a fókusz a lényegen van.
        </p>

        <div className="scroll-animate flex flex-wrap justify-center gap-3 mt-8">
          {chips.map((chip, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-on-dark/80 text-sm"
            >
              {chip}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MidAnchorSection;
